<template>
  <div class="price-control">
    <MaterialHeader />
    <div class="content-wrapper">
      <div class="content-title">价格管理（{{ materialTitle }}）</div>
      <div class="content-box">
        <el-table
          v-loading="loading"
          :data="priceList"
          border
          style="width: 100%"
          :header-cell-style="{
            color: 'rgba(13, 13, 13, 85)',
            'text-align': 'center',
          }"
        >
          <el-table-column
            align="center"
            prop="priceRegionName"
            label="价格区域"
          />
          <el-table-column align="center" label="价格(元)">
            <template slot-scope="{ row, $index }">
              <el-input
                v-model="row.itemPrice"
                placeholder="请输入价格"
                @blur="handleToFixed($index)"
              ></el-input>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="!loading" class="text--red">以上价格均为不含税价格</div>
        <div class="footer">
          <el-button @click="handleBtn('cancel')">取消</el-button>
          <el-button type="primary" @click="handleBtn('save')">保存</el-button>
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <div v-if="operatingBtnType === 'save'" class="hint">是否确定保存？</div>
      <div v-if="operatingBtnType === 'cancel'" class="hint">
        您还有信息未保存，是否取消?
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import bccApi from '@/api/bcc'
import formValidators from '@/utils/formValidators'
import MaterialHeader from './components/material-header'
export default {
  name: 'price-control',
  components: {
    MaterialHeader
  },
  data () {
    return {
      dialogVisible: false,
      priceList: [],
      operatingBtnType: '',
      materialTitle: '',
      loading: false
    }
  },
  computed: {
    type () {
      return this.$route.query.type
    }
  },
  created () {
    const itemCode = this.$route.query.itemCode
    this.getMaterialInfo(itemCode)
  },
  methods: {
    // 获取物料信息
    async getMaterialInfo (itemCode) {
      this.loading = true
      const { data } = await bccApi.getTradeItemInfo(itemCode)
      this.loading = false
      if (data.resultCode === '0') {
        const info = data.resultData?.tradeItemInfo || {}
        this.materialTitle = `${info.itemCode || ''}${
          info.itemName ? '/' + info.itemName : ''
        }`
        this.priceList = info.priceRegionLinkList || []
        this.priceList.map((item) => {
          item.itemPrice = this.setToFixed(item.itemPrice)
          return item
        })
      }
    },

    // 取消 保存
    handleBtn (val) {
      this.operatingBtnType = val
      this.dialogVisible = true
    },

    // 弹框确认
    handleConfirm () {
      if (this.operatingBtnType === 'cancel') {
        this.$router.back()
        return
      }
      this.updateTradeItemPriceRegion()
    },

    // 保存
    async updateTradeItemPriceRegion () {
      const { data } = await bccApi.updateTradeItemPriceRegion(this.priceList)
      this.dialogVisible = false
      if (data.resultCode === '0') {
        this.$message.success('保存成功')
        this.$router.replace({
          path: '/bcc/material/list'
        })
      }
    },

    handleToFixed (index) {
      const obj = { ...this.priceList[index] }
      if (obj.itemPrice === '') return
      formValidators.checkDecimals('', obj.itemPrice, (error) => {
        if (error) {
          this.$message.error(`${error.message}`)
        }
      })
      obj.itemPrice = this.setToFixed(obj.itemPrice)
      this.priceList.splice(index, 1, obj)
    },
    setToFixed (num) {
      if (Math.ceil(num) > 0) {
        return Number(num).toFixed(2)
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.content-title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 15px;
}
.content-box {
  border-radius: 10px;
  background-color: #fff;
  padding: 20px;
}
.content-wrapper {
  width: 800px;
}
</style>
<style lang="scss">
.price-control {
  .el-input {
    width: 150px;
    & > input {
      text-align: center;
    }
  }
  .footer {
    width: 300px;
    margin: 40px auto;
    display: flex;
    justify-content: space-around;
  }
  .el-dialog__header,
  .el-dialog__footer {
    border: 0;
    .el-button {
      width: 70px;
    }
  }
  .hint {
    text-align: center;
    font-size: $font-16;
  }
  .text--red {
    text-align: end;
    margin: 10px;
    color: $base-red;
  }
}
</style>
